export default {
  title: 'E-Payslip',
  form: {
    month: {
      placeholder: 'Month'
    }
  },
  button: {
    forgotPassword: 'Forgot Password'
  },
  table: {
    column: {
      period: 'Payment Period',
      description: 'Report Name'
    },
    button: {
      download: 'Download from Selected'
    }
  },
  forgotPassword: {
    button: 'Forgot Document Password',
    errors: {
      forbidden:
        'You do not have permission to send the ePay document password. Please contact your administrator.',
      tooManyRequests: 'Too many requests. Please wait and try again.',
      server: 'Internal Server Error. Please contact your administrator.',
      connection: 'Unable to connect to the system. Please try again.',
      failed:
        'Unable to send the ePay document password. Please contact your administrator.'
    },
    modalInfo: {
      title:
        'The system will send the password via email. Would you like to continue?',
      button: {
        ok: 'OK',
        cancel: 'Cancel'
      }
    },
    modalSuccess: {
      title: 'The document password has been sent to your registered email.',
      button: {
        ok: 'OK'
      }
    }
  }
}
